import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";

const selectSelf = (state: RootState) => state.receipt;

export const selectReceipt = createSelector(selectSelf, (state) => state.current);
